<ng-container *ngIf="!isModal">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <div class="content-wrapper">
    <section class="content">
      <app-breadcrumb
        Titulo="Nova Audiência"
        Pagina="Novo"
        [TemPaginaPai] = true
        LinkPaginaPai="/juridico/audiencia"
        PaginaPai="Audiência"
      ></app-breadcrumb>
      <div class="row" style="width: 101%">
        <div class="col-md-12">
          <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<div class="modal-overlay" *ngIf="isModal && modalNovoAudiencia" (click)="!loading && fecharModal()">
  <div class="box-audiencia-novo" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-calendar"></i> Nova Audiência
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
  </div>
</div>

<ng-template #formTemplate>
  <div [ngClass]="{'card card-blue': !isModal}">
    <form [formGroup]="formCadastrar" id="formCadastrar">
      <div [ngClass]="{'card-body': !isModal}">
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label>Processo <span class="text-danger">*</span></label>
              <ng-select [items]="listaProcessos"
                         bindLabel="numero"
                         bindValue="id"
                         formControlName="processoId"
                         placeholder="Selecione o processo"
                         [ngClass]="{'is-invalid': formCadastrar.get('processoId')?.invalid && formCadastrar.get('processoId')?.touched}">
                <ng-template ng-label-tmp let-item="item">
                  {{item.numero}} - {{item.titulo}}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{item.numero}} - {{item.titulo}}
                </ng-template>
              </ng-select>
              <span class="error mensagem-erro" *ngIf="formCadastrar.get('processoId')?.touched && formCadastrar.get('processoId')?.errors?.required">
                O processo deve ser selecionado
              </span>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label>Local <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="local" placeholder="Local da audiência"
                     [ngClass]="{'is-invalid': formCadastrar.get('local')?.invalid && formCadastrar.get('local')?.touched}">
              <span class="error mensagem-erro" *ngIf="formCadastrar.get('local')?.touched && formCadastrar.get('local')?.errors?.required">
                O local é obrigatório
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label>Data <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="dataAudiencia"
                     [ngClass]="{'is-invalid': formCadastrar.get('dataAudiencia')?.invalid && formCadastrar.get('dataAudiencia')?.touched}">
              <span class="error mensagem-erro" *ngIf="formCadastrar.get('dataAudiencia')?.touched && formCadastrar.get('dataAudiencia')?.errors?.required">
                A data é obrigatória
              </span>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label>Hora <span class="text-danger">*</span></label>
              <input type="time" class="form-control" formControlName="horaAudiencia"
                     [ngClass]="{'is-invalid': formCadastrar.get('horaAudiencia')?.invalid && formCadastrar.get('horaAudiencia')?.touched}">
              <span class="error mensagem-erro" *ngIf="formCadastrar.get('horaAudiencia')?.touched && formCadastrar.get('horaAudiencia')?.errors?.required">
                A hora é obrigatória
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn btn-light" (click)="voltar()" [disabled]="loading">
              {{ isModal ? 'Cancelar' : 'Voltar' }}
            </button>
            <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="loading || formCadastrar.invalid">
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ loading ? 'Salvando...' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
